import cn from 'classnames'
import { useFormikContext } from 'formik'
import { isEmpty } from 'lodash'

const PosAccount = ({
  settings,
  isActiveAndNotNewAccount,
  isDeactivatedAccount,
  handleAccountStatusClick,
  showValidationErrors,
  setShowValidationErrors,
}) => {
  const { dirty, errors } = useFormikContext()

  const disableUpdateButton = (dirty, errors) => {
    const disableButton =
      !dirty || (showValidationErrors && !isEmpty(errors))

    return disableButton
  }

  const onClickSaveButton = () => {
    setShowValidationErrors(true)
  }

  return (
    <div
      className={cn('item-settings', {
        '-double-btn': isActiveAndNotNewAccount,
      })}
    >
      {settings?.map(
        ({ Component, isVisible = true, ...props }, index) =>
          isVisible && <Component key={index} {...props} />
      )}
      <div className="btn-wrapper">
        <button
          className="btn -update"
          onClick={onClickSaveButton}
          disabled={disableUpdateButton(dirty, errors)}
          type="submit"
        >
          Save
        </button>
        {isActiveAndNotNewAccount && (
          <button
            className={cn('btn -outline ', {
              '-danger': !isDeactivatedAccount,
            })}
            onClick={() => handleAccountStatusClick('deactivate')}
            type="button"
          >
            Deactivate POS Account
          </button>
        )}
      </div>
    </div>
  )
}

export default PosAccount
